import CommentCreator from '../components/comment-creator';
import { addComment } from '../../../actions';
import { getConfig } from '../../../constants';
import { getId } from '../../../store/selectors';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
	config: getConfig(getId(state))
});

export default connect(
	mapStateToProps,
	{ addComment }
)(CommentCreator);

